import { Action, AvailableToReturnState } from './types'

export const setAvailableToReturn = (
    availableToReturn: AvailableToReturnState
) => ({
    type: 'SET_AVAILABLE_TO_RETURN',
    payload: {
        availableToReturn,
    },
})

const availableToReturnReducer: React.Reducer<
    AvailableToReturnState,
    Action
> = (state: AvailableToReturnState, action: Action) => {
    switch (action.type) {
        case 'SET_AVAILABLE_TO_RETURN':
            return {
                ...state,
                ...action.payload.availableToReturn,
            }

        default:
            return state
    }
}

export default availableToReturnReducer
